import React, { useState, useEffect } from 'react'
import { Button, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useTheme } from '@mui/material'
import { Item } from '../../../common/snippets'
import { Box } from '@mui/system'
import ReactHtmlTableToExcel from 'react-html-table-to-excel'
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import { callAddFontRobotoBold } from "../../../common/font/Roboto-bold"
import { callAddFontRobotoMedium } from "../../../common/font/Roboto-Medium-normal"
import * as sx from '../../../common/stylesInline/report_daily_branch'
import { useSelector } from 'react-redux'
import { colors } from '../../../common/helper'
import moment from 'moment'
import * as id from '../reportId'
import { focusElemnt, navigation3 } from '../../../common/helper'
import { detailedColumnsStyles, excelHeader, jsPdfHeaderFooter, PDFHeaderColumnsForStationWise, StationWiseSummaryColumn, summaryColumnsStyles } from './constant'



const StationWiseDefaultView = ({ dispatchResisterTableData,HeaderData,UseToPayAsCOD }) => {
  const { loginData } = useSelector(state => state?.common)
  const [searchResult, setSearchResult] = useState(true)
  const theme = useTheme()
  const { tableHeaderColor } = theme
  const [showTableData, setShowTableData] = useState([])
  const [state, setState] = useState({
    generatePDF: false,
    load: false,
  })
  const { generatePDF, load, } = { ...state }
  const currentDateTime = moment(window.getTime ? window.getTime() : new Date()).format('DD-MMM-YYYY HH:mm');

  const [tableOneDataForDetailed, setTableOneDataForDetailed] = useState([])
  const [tableOneDataForSummary, setTableOneDataForSummary] = useState([])

  useEffect(() => {
    let arr1 = dispatchResisterTableData?.Table?.map((val) => ({ ...val }))
    let TotalQuantity = 0
    let TotalFrtChrg = 0
    let TotalF_S_Tax = 0
    let TotalCartage = 0
    let TotalC_S_Tax = 0
    let TotalHamChrg = 0
    let TotalOperatorHamaliChg = 0
    let TotalPAID = 0
    let TotalTO_PAY = 0
    let TotalNetAmount = 0

    arr1?.forEach((val) => {
        TotalQuantity += Number(val.Qty)
        TotalFrtChrg += Number(val.Freight)
        TotalF_S_Tax += Number(val.F_S_Tax)
        TotalCartage += Number(val.Cartage)
        TotalC_S_Tax += Number(val.C_S_Tax)
        TotalHamChrg += Number(val.Hamali)
        TotalOperatorHamaliChg += Number(val.OperatorHamaliChg)
        TotalPAID += Number(val.PAID)
        TotalTO_PAY += Number(val.TO_PAY)
        TotalNetAmount += Number(val.Total)
    })

    arr1?.push({
        Date: `Total`,
        Qty:TotalQuantity.toFixed(2),
        Freight:TotalFrtChrg.toFixed(2),
        F_S_Tax: TotalF_S_Tax.toFixed(2),
        Cartage: TotalCartage.toFixed(2),
        C_S_Tax: TotalC_S_Tax.toFixed(2),
        Hamali: TotalHamChrg.toFixed(2),
        OperatorHamaliChg: TotalOperatorHamaliChg.toFixed(2),
        PAID: TotalPAID.toFixed(2),
        TO_PAY: TotalTO_PAY.toFixed(2),
        Total: TotalNetAmount.toFixed(2),
        isTotal: true,
    })

    let arr2 = dispatchResisterTableData?.Table1?.map((val) => ({ ...val, Col: ':' }))
    let TotalTotal_Items = 0
    let TotalTotal_Amount = 0

    arr2?.forEach((val) => {
        TotalTotal_Items += Number(val.Total_Items)
        TotalTotal_Amount += Number(val.Total_Amount)
    })

    arr2?.push({
        PaymentType: `All Total`,
        Total_Items: TotalTotal_Items.toFixed(2),
        Total_Amount:TotalTotal_Amount.toFixed(2),
        isTotal: true,
    })

    setTableOneDataForDetailed(arr1)
    setTableOneDataForSummary(arr2)
}, [dispatchResisterTableData])


  // const HeaderData = {
  //   FromDate: 'Dispatch From Date',
  //   ToDate: 'Dispatch To Date',
  //   FromCity: 'Dispatch From City',
  //   FromBranch: 'Dispatch From Branch',
  //   DispatchView: 'Dispatch View',
  //   ToStation: 'To Station',
  //   ToBranch: 'To Branch',
  //   PaymentType: 'Payment Type',
  //   ReportView: 'Report View',
  // }
  const updatedPDFHeaderColumns = PDFHeaderColumnsForStationWise.map((col) => {
    if (UseToPayAsCOD === 1 && col.field === 'TO_PAY') {
      return { ...col, headerName: 'COD', exportHead: 'COD' };
    }
    return col;
  });
  const printClick = (isSave) => {
    setState({ ...state, load: true, generatePDF: true })
    jsPDF.API.events.push(["addFonts", callAddFontRobotoBold]);
    jsPDF.API.events.push(["addFonts", callAddFontRobotoMedium]);
    const HeaderColumns = excelHeader.map((col) => {
      return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
    })
    const pdfDetailColumns = updatedPDFHeaderColumns.map((col) => {
      return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
    })
    const pdfSummaryColumns = StationWiseSummaryColumn.map((col) => {
      return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
    })
    const doc = new jsPDF({ orientation: 'p', format: [1240, 1754], unit: 'px', compress: true })
    var totalPagesExp = '{total_pages_count_string}'
    doc.setProperties({
      title: `Dispatch Register Report.pdf`,
      subject: 'Dispatch Register Report',
      author: 'Maven Tech Labs Pvt. Ltd.',
      keywords: 'maven tech, Cargo system, Receive',
      creator: 'MTLPL',
    })
    autoTable(doc, {
      margin: { top: 60, left: 30, right: 30, bottom: 5 },
      alternateRowStyles: {
        fillColor: [255, 255, 255],
      },
      columns: HeaderColumns,
      body: [HeaderData],
      columnStyles: {
        0: { fontSize: 18, valign: "middle", font: 'Roboto', fontStyle: "normal", cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0] },
        1: { fontSize: 18, valign: "middle", font: 'Roboto', fontStyle: "normal", cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0] },
        2: { fontSize: 18, valign: "middle", font: 'Roboto', fontStyle: "normal", cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0] },
        3: { fontSize: 18, valign: "middle", font: 'Roboto', fontStyle: "normal", cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0] },
        4: { fontSize: 18, valign: "middle", font: 'Roboto', fontStyle: "normal", cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0] },
        5: { fontSize: 18, valign: "middle", font: 'Roboto', fontStyle: "normal", cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0] },
        6: { fontSize: 18, valign: "middle", font: 'Roboto', fontStyle: "normal", cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0] },
        7: { fontSize: 18, valign: "middle", font: 'Roboto', fontStyle: "normal", cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0] },
        8: { fontSize: 18, valign: "middle", font: 'Roboto', fontStyle: "normal", cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0] },
      },
      theme: 'grid',
      startY: 160,
      headStyles: {
        fillColor: [191, 225, 255],
        textColor: [0, 0, 0],
        minCellHeight: 36,
        valign: 'middle',
        cellPadding: 12,
        fontSize: 18,
        font: 'Roboto',
        fontStyle: 'normal',
        lineWidth: 0.6,
      },
      didDrawPage: function (data) {
        doc.setTextColor(0, 0, 0)
        doc.setFontSize(18).setFont('Roboto', 'bold')
        // doc.text(`Booking Date : ${HeaderData?.fromDate}  To  ${HeaderData.toDate}`, data.settings.margin.left, 150)
        // doc.text(`Report: ${HeaderData.reportOptions}`, doc.internal.pageSize.width - data.settings.margin.left, 150, "right")
      },
    })

    autoTable(doc, {
      margin: { top: 120, left: 30, right: 30, bottom: 40 },
      alternateRowStyles: {
        fillColor: [255, 255, 255],
      },
      headStyles: {
        fillColor: [191, 225, 255],
        fontSize: 16,
        minCellHeight: 36,
        cellPadding: 6,
        valign: 'top',
        fontStyle: 'normal',
        font: 'Roboto',
        textColor: [0, 0, 0]
      },
      tableLineWidth: 0.6,
      columns: pdfDetailColumns,
      body: tableOneDataForDetailed,
      styles: {
        lineWidth: [0, 0.2, 0, 0.2]
      },
      theme: 'grid',
      columnStyles: detailedColumnsStyles,
      didParseCell: (data) => {
        // DetailsDrawCell(data)
        if (data.row.section === 'head') {
          if (['number', 'quantity', 'currency'].indexOf(data.column.raw.xlCol.dataType) !== -1) {
            data.cell.styles.halign = "right";
          } else {
            data.cell.styles.halign = "left";
          }
        }
      },
      willDrawCell: (data) => {
        if (data.row.raw.isTotal) {
          doc.setFillColor(238, 238, 238);
          doc.setFontSize(16)
          doc.setTextColor(0, 0, 0);
          data.cell.styles.valign = 'middle';
        }

      },
      didDrawPage: function (data) {
        doc.setTextColor(40)
        doc.addImage('/images/logo-66.png', 'JPEG', 30, 50, 50, 50)
        doc.setFontSize(26).setFont("Roboto", 'bold')
        doc.setTextColor(16, 79, 162)
        doc.text('Cargo System |  Dispatch Register Report', 30 + 60, 80)
        doc.setTextColor(0, 0, 0)
        doc.setFontSize(22).setFont("Roboto", 'bold')
        doc.text(`Company Name :${loginData.strCompanyName}`, doc.internal.pageSize.width - data.settings.margin.left, 80, "right")
        jsPdfHeaderFooter(data, loginData, totalPagesExp)
      },
    })
    autoTable(doc, {
      margin: { top: 120, left: 30, right: 30, bottom: 40 },
      alternateRowStyles: {
        fillColor: [255, 255, 255],
      },
      headStyles: {
        fillColor: [191, 225, 255],
        fontSize: 16,
        minCellHeight: 36,
        cellPadding: 6,
        valign: 'top',
        fontStyle: 'normal',
        font: 'Roboto',
        textColor: [0, 0, 0]
      },
      tableLineWidth: 0.6,
      columns: pdfSummaryColumns,
      body: tableOneDataForSummary,
      styles: {
        lineWidth: [0, 0.2, 0, 0.2]
      },
      theme: 'grid',
      columnStyles: summaryColumnsStyles,
      didParseCell: (data) => {
        // DetailsDrawCell(data)
        if (data.row.section === 'head') {
          if (['number', 'quantity', 'currency'].indexOf(data.column.raw.xlCol.dataType) !== -1) {
            data.cell.styles.halign = "right";
          } else {
            data.cell.styles.halign = "left";
          }
        }
      },
      willDrawCell: (data) => {
        if (data.row.raw.isTotal) {
          doc.setFillColor(238, 238, 238);
          doc.setFontSize(16)
          doc.setTextColor(0, 0, 0);
          data.cell.styles.valign = 'middle';
        }

      },
      didDrawPage: function (data) {
        doc.setTextColor(40)
        doc.addImage('/images/logo-66.png', 'JPEG', 30, 50, 50, 50)
        doc.setFontSize(26).setFont("Roboto", 'bold')
        doc.setTextColor(16, 79, 162)
        doc.text('Cargo System |  Dispatch Register Report', 30 + 60, 80)
        doc.setTextColor(0, 0, 0)
        doc.setFontSize(22).setFont("Roboto", 'bold')
        doc.text(`Company Name :${loginData.strCompanyName}`, doc.internal.pageSize.width - data.settings.margin.left, 80, "right")
        jsPdfHeaderFooter(data, loginData, totalPagesExp)
      },
    })
    doc.setFont('Roboto')

    if (typeof doc.putTotalPages === 'function') {
      doc.putTotalPages(totalPagesExp)
    }
    if (isSave) {
      doc.save(`Dispatch Register Report ${currentDateTime}.pdf`)
      setTimeout(() => {
        setState({ ...state, generatePDF: false, load: true })
        const pdfUrl = doc.output('bloburl')
        document.getElementById('gbDetailsOutput').data = pdfUrl
        // document.getElementById('gbDetailsOutput').data = doc.output('datauristring', 'Dispatch Register Report.pdf')
        focusElemnt("backBtn")
      }, 2000)
    } else {
      setTimeout(() => {
        setState({ ...state, generatePDF: false, load: true })
        const pdfUrl = doc.output('bloburl')
        document.getElementById('gbDetailsOutput').data = pdfUrl
        // document.getElementById('gbDetailsOutput').data = doc.output('datauristring', 'Dispatch Register Report.pdf')
        focusElemnt("backBtn")
      }, 2000)

    }
  }

  const InsideRowContent = ({ item, index }) => {
    return (
      <TableRow className="receivedTr" key={index}>
        {
          item?.isTotal ?
            <>
              <TableCell className="userWiseReportSubTotal" colSpan={2} style={{ textAlign: "left", backgroundColor: tableHeaderColor?.isTotalColor, height: "36px" }}>{item.Date}</TableCell>
              <TableCell className="userWiseReportSubTotal" colSpan={1} style={{ textAlign: "right", backgroundColor: tableHeaderColor?.isTotalColor, height: "36px" }}>{item.Qty}</TableCell>
              <TableCell className="userWiseReportSubTotal" colSpan={1} style={{ textAlign: "right", backgroundColor: tableHeaderColor?.isTotalColor, height: "36px" }}>{item.Freight}</TableCell>
              <TableCell className="userWiseReportSubTotal" colSpan={1} style={{ textAlign: "right", backgroundColor: tableHeaderColor?.isTotalColor, height: "36px" }}>{item.F_S_Tax}</TableCell>
              <TableCell className="userWiseReportSubTotal" colSpan={1} style={{ textAlign: "right", backgroundColor: tableHeaderColor?.isTotalColor, height: "36px" }}>{item.Cartage}</TableCell>
              <TableCell className="userWiseReportSubTotal" colSpan={1} style={{ textAlign: "right", backgroundColor: tableHeaderColor?.isTotalColor, height: "36px" }}>{item.C_S_Tax}</TableCell>
              <TableCell className="userWiseReportSubTotal" colSpan={1} style={{ textAlign: "right", backgroundColor: tableHeaderColor?.isTotalColor, height: "36px" }}>{item.Hamali}</TableCell>
              <TableCell className="userWiseReportSubTotal" colSpan={1} style={{ textAlign: "right", backgroundColor: tableHeaderColor?.isTotalColor, height: "36px" }}>{item.OperatorHamaliChg}</TableCell>
              <TableCell className="userWiseReportSubTotal" colSpan={1} style={{ textAlign: "right", backgroundColor: tableHeaderColor?.isTotalColor, height: "36px" }}>{item.PAID}</TableCell>
              <TableCell className="userWiseReportSubTotal" colSpan={1} style={{ textAlign: "right", backgroundColor: tableHeaderColor?.isTotalColor, height: "36px" }}>{item.TO_PAY}</TableCell>
              <TableCell className="userWiseReportSubTotal" colSpan={1} style={{ textAlign: "right", backgroundColor: tableHeaderColor?.isTotalColor, height: "36px" }}>{item.Total}</TableCell>
            </>
            :
            <>
              <TableCell className="userwiseTD" colSpan={1} style={{ padding: "8px 9px", textAlign: "left", verticalAlign: "top", minWidth: "60px" }}>{item.Date}</TableCell>
              <TableCell className="userwiseTD" colSpan={1} style={{ padding: "8px 9px", verticalAlign: "top", textAlign: "left", borderRight: "none", maxWidth: "90px" }}>{item.vehicleNo}</TableCell>
              <TableCell className="userwiseTD" colSpan={1} style={{ padding: "8px 9px", textAlign: "right", verticalAlign: "top", maxWidth: "10px" }}>{item.Qty}</TableCell>
              <TableCell className="userwiseTD" colSpan={1} style={{ padding: "8px 9px", verticalAlign: "top", textAlign: "right", maxWidth: "100px" }}>{item.Freight}</TableCell>
              <TableCell className="userwiseTD" colSpan={1} style={{ padding: "8px 9px", verticalAlign: "top", textAlign: "right", maxWidth: "100px" }}>{item.F_S_Tax}</TableCell>
              <TableCell className="userwiseTD" colSpan={1} style={{ padding: "8px 9px", verticalAlign: "top", textAlign: "right", maxWidth: "80px" }}>{item.Cartage}</TableCell>
              <TableCell className="userwiseTD" colSpan={1} style={{ padding: "8px 9px", verticalAlign: "top", textAlign: "right", maxWidth: "80px" }}>{item.C_S_Tax}</TableCell>
              <TableCell className="userwiseTD" colSpan={1} style={{ verticalAlign: "top", textAlign: "right", }}>{item.Hamali}</TableCell>
              <TableCell className="userwiseTD" colSpan={1} style={{ verticalAlign: "top", textAlign: "right", }}>{item.OperatorHamaliChg}</TableCell>
              <TableCell className="userwiseTD" colSpan={1} style={{ verticalAlign: "top", textAlign: "right", }}>{item.PAID}</TableCell>
              <TableCell className="userwiseTD" colSpan={1} style={{ verticalAlign: "top", textAlign: "right" }} >{item.TO_PAY}</TableCell>
              <TableCell className="userwiseTD" colSpan={1} style={{ textAlign: "right", verticalAlign: "top" }}>{item.Total}</TableCell>
            </>
        }
      </TableRow>
    )
  }
  const InsideRowContentForSummary = ({ item, index }) => {
    return (
      <TableRow className="receivedTr" key={index}>
        {
          item?.isTotal ?
            <>
              <TableCell className="userWiseReportSubTotal" colSpan={2} style={{ textAlign: "right", backgroundColor: tableHeaderColor?.isTotalColor, height: "36px" }}>{item.PaymentType}</TableCell>
              <TableCell className="userWiseReportSubTotal" colSpan={1} style={{ textAlign: "right", backgroundColor: tableHeaderColor?.isTotalColor, height: "36px" }}>{item.Total_Items}</TableCell>
              <TableCell className="userWiseReportSubTotal" colSpan={1} style={{ textAlign: "right", backgroundColor: tableHeaderColor?.isTotalColor, height: "36px" }}>{item.Total_Amount}</TableCell>

            </>
            :
            <>
              <TableCell className="userwiseTD" colSpan={1} style={{ verticalAlign: "top", textAlign: "right", }}>{item.PaymentType}</TableCell>
              <TableCell className="userwiseTD" colSpan={1} style={{ verticalAlign: "top", textAlign: "right", }}>{item.Col}</TableCell>
              <TableCell className="userwiseTD" colSpan={1} style={{ verticalAlign: "top", textAlign: "right" }} >{item.Total_Items}</TableCell>
              <TableCell className="userwiseTD" colSpan={1} style={{ textAlign: "right", verticalAlign: "top" }}>{item.Total_Amount}</TableCell>
            </>
        }
      </TableRow>
    )
  }
  

  return (
    <>
      <Stack style={{ margin: "0px 10px", marginRight: "0px" }}>
        <Item className='userReport'>
          <Item className='userReport-heading'>
            Report For: Dispatch Register Report
          </Item>
          <Item className='userReport-buttons'>
            {searchResult ? <>
              <Box onKeyDown={(e) => navigation3(e, "ExportToPdf", id.reportmainButton, () => { })}>
                <ReactHtmlTableToExcel
                  id="ExportToExl"
                  className="userWisereporttemExcelBtn"
                  table="tables"
                  filename={`Dispatch Register Report`}
                  sheet="tablexls"
                  buttonText="Export to Excel"
                />
              </Box>
              <Box>
                <Button variant="outlined" className="userWisereporttembtn" id="ExportToPdf"
                  onClick={() => {
                    setSearchResult(false);
                    printClick(true)
                  }}
                // onKeyDown={(e) => navigation3(e, "PrintBtn", "ExportToExl", () => { setSearchResult(false); printClick(true) })}
                >
                  Export to Pdf
                </Button>
              </Box>
              <Box>
                <Button
                  variant="outlined" id="PrintBtn"
                  className="userWisereporttembtn"
                  onClick={() => {
                    setSearchResult(false);
                    printClick(false)
                  }}
                // onKeyDown={(e) => navigation3(e, id.fromDate, "ExportToPdf", () => { setSearchResult(true); printClick(false) })}
                >
                  Print
                </Button>
              </Box>
            </> : <>
              <Box>
                <Button
                  variant="outlined" id="backBtn"
                  className="userWisereporttembtn"
                  onClick={() => { setSearchResult(true) }}
                // onKeyDown={(e) => navigation3(e, id.fromDate, id.reportmainButton, () => { setSearchResult(true); setLargePDF(false); focusElemnt(id.reportmainButton) })}
                >
                  Back
                </Button>
              </Box>
            </>}

          </Item>
        </Item>
      </Stack>
      {
        searchResult ?
          <Stack sx={{ marginLeft: 2, marginRight: 1, height: 470 }} className="scroll">
            <TableContainer className="lr-popup-table lrModel " component={Paper} style={{ borderRadius: "6px", border: '1px solid #aeaeae' }}>
              <Table id="tables">
                <Table size="small" aria-label="a dense table" style={{ marginBottom: '10px' }}>
                  <TableHead style={{ display: 'none', fontWeight: 'bold' }}>
                    <TableRow>
                      <TableCell className="reportTD" style={{ fontSize: '24px', fontWeight: '600', textAlign: 'left' }} colSpan={6}>
                        <h3 style={{ paddingLeft: '17px' }}>Report For: Dispatch Register Reports</h3>
                      </TableCell>
                      <TableCell className="reportTD" style={{ fontSize: '24px', fontWeight: '600', textAlign: 'left' }} colSpan={5}>
                        <h3 style={{ paddingLeft: '17px' }}>Company Name :{loginData.strCompanyName} </h3>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell colSpan={11}></TableCell>
                    </TableRow>
                    <TableRow style={{ color: 'white' }}>
                      {excelHeader?.map((item, i) =>
                        <TableCell
                          className="ReportItemHead"
                          style={{ backgroundColor: '#e5f3ff', color: '#454646', fontSize: '20px', fontWeight: '600', textAlign: "left" }}
                          colSpan={item.colspan}
                          key={i}
                        >
                          {item.headerName}
                        </TableCell>
                      )}
                    </TableRow>
                    <TableRow>
                      <TableCell
                        className="reportTD"
                        style={{ fontSize: '20px', fontWeight: '600', textAlign: "left" }}
                        colSpan={1}
                      >
                        {/* {moment(headerData.fromDate).format('DD-MMM-YYYY')} */}
                        {HeaderData.FromDate}
                      </TableCell>
                      <TableCell
                        className="reportTD"
                        style={{ fontSize: '20px', fontWeight: '600', textAlign: "left" }}
                        colSpan={1}
                      >
                        {/* {moment(headerData.toDate).format('DD-MMM-YYYY')} */}
                        {HeaderData.ToDate}
                      </TableCell>
                      <TableCell
                        className="reportTD"
                        style={{ fontSize: '20px', fontWeight: '600', textAlign: "left" }}
                        colSpan={1}
                      >
                        {/* {headerData.selSelectedCity} */}
                        {HeaderData.FromCity}
                      </TableCell>
                      <TableCell
                        className="reportTD"
                        style={{ fontSize: '20px', fontWeight: '600', textAlign: "left" }}
                        colSpan={2}
                      >
                        {/* {headerData?.selSelectedBranch} */}
                        {HeaderData.FromBranch}
                      </TableCell>
                      <TableCell
                        className="reportTD"
                        style={{ fontSize: '20px', fontWeight: '600', textAlign: "left" }}
                        colSpan={1}
                      >
                        {/* {headerData?.paymentType} */}
                        {HeaderData.DispatchView}
                      </TableCell>
                      <TableCell
                        className="reportTD"
                        style={{ fontSize: '20px', fontWeight: '600', textAlign: "left" }}
                        colSpan={2}
                      >
                        {/* {headerData?.reportView} */}
                        {HeaderData.ToStation}
                      </TableCell>
                      <TableCell
                        className="reportTD"
                        style={{ fontSize: '20px', fontWeight: '600', textAlign: "left" }}
                        colSpan={1}
                      >
                        {/* {headerData?.reportOptions} */}
                        {HeaderData.ToBranch}
                      </TableCell>
                      <TableCell
                        className="reportTD"
                        style={{ fontSize: '20px', fontWeight: '600', textAlign: "left" }}
                        colSpan={1}
                      >
                        {/* {headerData?.reportOptions} */}
                        {HeaderData.PaymentType}
                      </TableCell>
                      <TableCell
                        className="reportTD"
                        style={{ fontSize: '20px', fontWeight: '600', textAlign: "left" }}
                        colSpan={1}
                      >
                        {/* {headerData?.reportOptions} */}
                        {HeaderData.ReportView}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell colSpan={11}></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableHead style={{ position: `sticky`, top: `0`, background: `white`, borderRadius: "10px 10px 10px 10px" }}>
                    <TableRow className='sammary-heading' style={{ borderRadius: "10px 10px 10px 10px" }}>
                      {updatedPDFHeaderColumns?.map((item, i) =>
                        <TableCell className="userWiseReportHeading" key={i} style={{ textAlign: item.align, verticalAlign: "top", color: tableHeaderColor.textColor, backgroundColor: tableHeaderColor.isHeadingColor, whiteSpace: "pre-line" }}>{item?.headerName}</TableCell>
                      )}
                    </TableRow>
                  </TableHead>
                  {tableOneDataForDetailed?.length < 0 ? (
                    <>
                      <TableBody>
                        <TableRow>
                          <TableCell colSpan={14}>
                            <div
                              style={{
                                display: 'flex',
                                justifyContent: 'center',
                                marginTop: '20px',
                                marginBottom: '20px',
                                color: 'red',
                                fontSize: '14px',
                              }}
                            >
                              <span>No results found. Please refine your search parameters and search again.</span>
                            </div>
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </>
                  ) : tableOneDataForDetailed?.length > 0 ? (
                    <TableBody className="filter-data-row-BorderNone" sx={{ border: "none !important" }}>
                      {tableOneDataForDetailed?.map((item, index) => (
                        <InsideRowContent item={item} index={index} key={index} />
                      ))}
                    </TableBody>
                  ) : (
                    ''
                  )}
                </Table>
                <Table size="small" aria-label="a dense table">
                  <TableHead>
                    <TableRow>
                      <TableCell style={{ fontSize: '12px' }}>
                        Payment Typewise Summary
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableHead style={{ position: `sticky`, top: `0`, background: `white`, borderRadius: "10px 10px 10px 10px" }}>
                    <TableRow className='sammary-heading' style={{ borderRadius: "10px 10px 10px 10px" }}>
                      {StationWiseSummaryColumn?.map((item, i) =>
                        <TableCell className="userWiseReportHeading" key={i} style={{ textAlign: item.align, verticalAlign: "top", color: tableHeaderColor.textColor, backgroundColor: tableHeaderColor.isHeadingColor, whiteSpace: "pre-line" }}>{item?.headerName}</TableCell>
                      )}
                    </TableRow>
                  </TableHead>
                  {tableOneDataForSummary?.length < 0 ? (
                    <>
                      <TableBody>
                        <TableRow>
                          <TableCell colSpan={14}>
                            <div
                              style={{
                                display: 'flex',
                                justifyContent: 'center',
                                marginTop: '20px',
                                marginBottom: '20px',
                                color: 'red',
                                fontSize: '14px',
                              }}
                            >
                              <span>No results found. Please refine your search parameters and search again.</span>
                            </div>
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </>
                  ) : tableOneDataForSummary?.length > 0 ? (
                    <TableBody className="filter-data-row-BorderNone" sx={{ border: "none !important" }}>
                      {tableOneDataForSummary?.map((item, index) => (
                        <InsideRowContentForSummary item={item} index={index} key={index} />
                      ))}
                    </TableBody>
                  ) : (
                    ''
                  )}
                </Table>
              </Table>
            </TableContainer>

          </Stack>
          :
          <>
            <Box sx={{ ...sx.reportFlex, justifyContent: 'center' }}>
              {generatePDF ? <div className={'generatePDF'}>Generating PDF....</div> : ''}
              {load ? (
                <object
                  id="gbDetailsOutput"
                  type="application/pdf"
                  width={"100%"}
                  height="440"
                  title="MTLPL -Cargo System -Good Balance Report"
                  aria-label="MTLPL -Cargo System -Good Balance Report"
                ></object>
              ) : (
                ''
              )}
              {/* </>
                        } */}
            </Box>
          </>

      }

    </>
  )
}

export default StationWiseDefaultView
